// extracted by mini-css-extract-plugin
export default {"title":"Multimedia_title__aukJW","infoIcon":"Multimedia_infoIcon__ZUoD+","fileInputContainer":"Multimedia_fileInputContainer__5QDsV"};